import { Component, OnInit } from '@angular/core';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-postion-edit',
  templateUrl: './postion-edit.component.html',
  styleUrls: ['./postion-edit.component.css']
})
export class PostionEditComponent implements OnInit {
  years: number[] = [2018, 2017, 2016, 2015, 2014];
  months: number[] = [7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6];
  year: number;
  month: number;

  logininfo: Logininfo = this.auth.loginID;
  constructor(
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
  }

  changeRecord() {

  }

  SearchRecord() {

  }

}
